import { CSSProperties, RefObject, useEffect, useState } from 'react';

import { HEADER_TRANSITION, zIndexes } from '@core/constant';
import { useContextHeaderHeight, useContextMediaQuery } from '@core/context';
import { ESize, EZIndexName } from '@core/type';

const FULL_HEIGHT = 100;

export const ProgressLine = ({
  blockRef,
  styleProps,
}: {
  blockRef: RefObject<HTMLElement>;
  styleProps?: CSSProperties;
}) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  const { height: top } = useContextHeaderHeight();
  const { isTablet, mediaQuery } = useContextMediaQuery();

  const handleScroll = () => {
    const blockElement = blockRef.current;

    if (blockElement) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const articleTop = blockElement.offsetTop;
      const articleHeight = blockElement.offsetHeight;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      const scrollPosition = Math.max(0, scrollTop - articleTop);
      const progress = Math.min(
        FULL_HEIGHT,
        (scrollPosition / (articleHeight - windowHeight)) * FULL_HEIGHT,
      );

      setScrollProgress(progress);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isSmallDesktop: boolean = mediaQuery === ESize.LG;

  return (
    <progress
      style={{
        width: '100%',
        marginTop: isSmallDesktop ? '-5px' : isTablet ? '-17px' : '-2px',
        position: 'fixed',
        left: 0,
        height: '6px',
        transition: HEADER_TRANSITION,
        zIndex: zIndexes[EZIndexName.HOVER_EFFECT],
        top,
        ...styleProps,
      }}
      value={scrollProgress}
      max="100"
    />
  );
};
